import React, { useState } from 'react';
import PlanejamentoAulas from './PlanejamentoAulas.jsx';
import MateriaisDidaticos from './MateriaisDidaticos.jsx';
import AnotacoesOcorrencias from './AnotacoesOcorrencias.jsx';
import RelatoriosPorAluno from './RelatoriosPorAluno.jsx';
import RelatoriosPorTurma from './RelatoriosPorTurma.jsx';
import './OrganizacaoProfessor.css';

const OrganizacaoProfessor = () => {
  const [activeSection, setActiveSection] = useState('planejamento');

  const menuItems = [
    {
      id: 'planejamento',
      title: 'Planejamento de Aulas',
      icon: '📚',
      description: 'Organize e planeje suas aulas semanalmente'
    },
    {
      id: 'materiais',
      title: 'Materiais Didáticos',
      icon: '📋',
      description: 'Gerencie seus materiais e recursos pedagógicos'
    },
    {
      id: 'anotacoes',
      title: 'Anotações/Ocorrências',
      icon: '📝',
      description: 'Registre anotações e ocorrências diárias'
    },
    {
      id: 'relatorios-aluno',
      title: 'Relatórios por Aluno',
      icon: '👤',
      description: 'Acompanhe o desenvolvimento individual dos alunos'
    },
    {
      id: 'relatorios-turma',
      title: 'Relatórios por Turma',
      icon: '👥',
      description: 'Visualize relatórios e estatísticas da turma'
    }
  ];

  const renderContent = () => {
    switch (activeSection) {
      case 'planejamento':
        return <PlanejamentoAulas />;
      case 'materiais':
        return <MateriaisDidaticos />;
      case 'anotacoes':
        return <AnotacoesOcorrencias />;
      case 'relatorios-aluno':
        return <RelatoriosPorAluno />;
      case 'relatorios-turma':
        return <RelatoriosPorTurma />;
      default:
        return <PlanejamentoAulas />;
    }
  };

  return (
    <div className="organizacao-professor-container">
      <div className="organizacao-header">
        <div className="header-content">
          <h1>🎓 Organização do Professor</h1>
          <p>Ferramentas completas para gerenciar sua rotina docente</p>
        </div>
      </div>

      <div className="organizacao-layout">
        <aside className="sidebar-menu">
          <div className="menu-header">
            <h3>📋 Menu</h3>
            <p>Selecione uma opção</p>
          </div>
          
          <nav className="menu-items">
            {menuItems.map((item) => (
              <button
                key={item.id}
                className={`menu-item ${activeSection === item.id ? 'active' : ''}`}
                onClick={() => setActiveSection(item.id)}
              >
                <div className="menu-icon">{item.icon}</div>
                <div className="menu-content">
                  <h4>{item.title}</h4>
                  <p>{item.description}</p>
                </div>
                <div className="menu-arrow">→</div>
              </button>
            ))}
          </nav>

          <div className="menu-footer">
            <div className="quick-stats">
              <div className="stat-item">
                <span className="stat-number">12</span>
                <span className="stat-label">Aulas Planejadas</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">48</span>
                <span className="stat-label">Materiais</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">7</span>
                <span className="stat-label">Ocorrências</span>
              </div>
            </div>
          </div>
        </aside>

        <main className="content-area">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default OrganizacaoProfessor;
